import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

type ClientEquipment = {
	brand?: string | null;
	model?: string | null;
};

type RepairSummary = {
	repairNumber?: string | number | null;
	clientEquipment?: ClientEquipment | null;
};

type CommissionEntry = {
	repair?: RepairSummary | null;
	repairValue?: number | null;
	totalMaterial?: number | null;
	value?: number | null;
};

type CommissionsTableProps = {
	commissions?: CommissionEntry[];
};

const formatCurrency = (value: number) =>
	new Intl.NumberFormat("pt-PT", {
		style: "currency",
		currency: "EUR",
		maximumFractionDigits: 2,
	}).format(value);

const normalizeNumber = (value: number | null | undefined) => {
	const parsed = Number(value ?? 0);
	return Number.isNaN(parsed) ? 0 : parsed;
};

const formatEquipmentLabel = (equipment?: ClientEquipment | null) => {
	if (!equipment) {
		return "-";
	}

	const brand = equipment.brand?.trim() ?? "";
	const model = equipment.model?.trim() ?? "";
	const label = `${brand} ${model}`.trim();
	return label.length > 0 ? label : "-";
};

export function CommissionsTable({ commissions = [] }: CommissionsTableProps) {
	return (
		<div className="rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead>#</TableHead>
						<TableHead>Equipamento</TableHead>
						<TableHead>Valor da Reparação</TableHead>
						<TableHead>Material</TableHead>
						<TableHead>A receber</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{commissions.map((entry) => {
						const repairNumber = entry.repair?.repairNumber ?? "-";
						const equipmentLabel = formatEquipmentLabel(
							entry.repair?.clientEquipment,
						);
						const rowKey = `${repairNumber}-${equipmentLabel}`;

						return (
							<TableRow key={rowKey}>
								<TableCell>{repairNumber}</TableCell>
								<TableCell>{equipmentLabel}</TableCell>
								<TableCell>
									{formatCurrency(normalizeNumber(entry.repairValue))}
								</TableCell>
								<TableCell>
									{formatCurrency(normalizeNumber(entry.totalMaterial))}
								</TableCell>
								<TableCell>
									{formatCurrency(normalizeNumber(entry.value))}
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</div>
	);
}
